<template>
  <div class="grid grid-cols-1 gap-8 w-full lg:grid-cols-2">
    <div
      v-for="(tool, index) in tools"
      :key="index"
      class="flex flex-col w-full border border-gray-200 rounded-lg shadow bg-[linear-gradient(180deg,_#FCFCFD_0%,_#F9FAFB_100%)]"
    >
      <div class="flex flex-col gap-1 p-6">
        <h1 class="text-2xl font-medium text-gray-900">
          {{ tool.name }}
        </h1>
        <p class="text-gray-700">
          {{ tool.description }}
        </p>
      </div>
      <img
        :src="tool.image"
        alt="tool-img"
        class="object-cover w-full h-40 sm:h-[268px]"
      >
    </div>
  </div>
</template>

<script setup lang="ts">
import { shallowRef } from "vue";
import ToolShapes from "@/../images/tabbed-bento-images/tools/shapes.png";
import ToolImages from "@/../images/tabbed-bento-images/tools/images.png";
import ToolTypes from "@/../images/tabbed-bento-images/tools/types.png";
import ToolLayers from "@/../images/tabbed-bento-images/tools/layers.png";

const tools = shallowRef([
    {
        name: "Shapes",
        description:
            "Simply pick a shape, resize, and watch your design come alive. Because in the world of postcards, shapes speak louder than words!",
        image: ToolShapes,
    },
    {
        name: "Images",
        description:
            "Stop wasting countless hours searching for the perfect image. Our  image library allows you to quickly find anything you need.",
        image: ToolImages,
    },
    {
        name: "Types",
        description:
            "Experiment with fonts, sizes, and colors to achieve the perfect look every time with our user-friendly editor. Your text, your way!",
        image: ToolTypes,
    },
    {
        name: "Layers",
        description:
            "Layers provide freedom to experiment with text, images, or shapes. Explore various arrangements to find your perfect balance.",
        image: ToolLayers,
    },
]);
</script>
